export enum merchantStatus {
    'no' = 1, // 未入驻
    'pending' = 2, // 认领中
    'success' = 3, // 入驻成功
}
